// Global cleanup function
function cleanupOrphanedMagnifiedImages() {
  // Remove any magnified images that might be stuck
  const existingMagnified = document.querySelectorAll(
    '[data-magnified-image="true"]'
  );
  existingMagnified.forEach((img) => {
    if (img.parentNode) {
      img.parentNode.removeChild(img);
    }
  });
}

const DENSITY_IMAGE_HEIGHTS = {
  comfortable: 62, // row height 67px - 5px padding
  standard: 47, // row height 52px - 5px padding
  compact: 31, // row height 36px - 5px padding
};

export function standardizeAndMagnifyEffectHtmlImages(
  data,
  type,
  row,
  density
) {
  if (!data) return null;

  // Clean up any orphaned magnified images first
  cleanupOrphanedMagnifiedImages();

  const imageHeight =
    DENSITY_IMAGE_HEIGHTS[density] ?? DENSITY_IMAGE_HEIGHTS.standard;

  // Create a temporary container to parse the HTML
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = data;

  // Find all img elements
  const images = tempDiv.querySelectorAll("img");

  if (images.length === 0) {
    return data;
  }

  // Process each image
  images.forEach((img, index) => {
    img.style.height = `${imageHeight}px`;
    img.style.width = "auto";
    img.style.cursor = "pointer";

    const uniqueId = `magnify-img-${Date.now()}-${index}`;
    img.id = uniqueId;

    // Add mouseenter handler
    img.setAttribute(
      "onmouseenter",
      `
      (function(e) {
        const img = e.target;
        if (img._magnifiedImg) return;

        const magnifiedImg = document.createElement('img');
        magnifiedImg.src = img.src;
        magnifiedImg.alt = img.alt || '';
        magnifiedImg.setAttribute('data-magnified-image', 'true');
        magnifiedImg.style.cssText = 'position: fixed; height: 300px; width: auto; z-index: 10000; border: 2px solid #333; border-radius: 4px; box-shadow: 0 4px 8px rgba(0,0,0,0.3); background: white; padding: 2px; pointer-events: none;';
        document.body.appendChild(magnifiedImg);
        img._magnifiedImg = magnifiedImg;

        const offset = 10;
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        const w = magnifiedImg.offsetWidth || 0;
        const h = magnifiedImg.offsetHeight || 300;
        let left = e.clientX + offset;
        let top = e.clientY + offset;
        if (left + w > vw) left = e.clientX - offset - w;
        if (top + h > vh) top = e.clientY - offset - h;
        if (left < 0) left = 0;
        if (top < 0) top = 0;
        magnifiedImg.style.left = left + 'px';
        magnifiedImg.style.top = top + 'px';
      })(event)
    `
    );

    // Add mousemove handler
    img.setAttribute(
      "onmousemove",
      `
      (function(e) {
        const img = e.target;
        if (!img._magnifiedImg) return;

        const magnifiedImg = img._magnifiedImg;
        const offset = 10;
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        const w = magnifiedImg.offsetWidth || 0;
        const h = magnifiedImg.offsetHeight || 300;
        let left = e.clientX + offset;
        let top = e.clientY + offset;
        if (left + w > vw) left = e.clientX - offset - w;
        if (top + h > vh) top = e.clientY - offset - h;
        if (left < 0) left = 0;
        if (top < 0) top = 0;
        magnifiedImg.style.left = left + 'px';
        magnifiedImg.style.top = top + 'px';
      })(event)
    `
    );

    // Add mouseleave handler
    img.setAttribute(
      "onmouseleave",
      `
      (function(e) {
        const img = e.target;
        if (img._magnifiedImg && img._magnifiedImg.parentNode) {
          img._magnifiedImg.parentNode.removeChild(img._magnifiedImg);
          delete img._magnifiedImg;
        }
      })(event)
    `
    );
  });

  return tempDiv.innerHTML;
}
